// extracted by mini-css-extract-plugin
module.exports = {"cells":"modifyInfo_cells_1eQTj","avater":"modifyInfo_avater_2zTn5","cellitem":"modifyInfo_cellitem_1Sjjp"};